import { useGlobalModal } from 'hooks';
import PublicationSetupModal from '../publication-setup-modal/PublicationSetupModal';
import { useState } from 'react';
import PublicationValidationView from '../publication-validation-view/PublicationValidationView';

const PublicationProductToWalmartRecipients = (props) => {
  const { isFullView, productId = null } = props;

  const [requestParams, setRequestParams] = useState(null);

  const { MODAL_NAMES, checkModalVisible, closeModal, openModal } =
    useGlobalModal();

  const isModalPublicationWalmartVisible = checkModalVisible(
    MODAL_NAMES.PUBLICATION_WALMART_SETUP_MODAL
  );

  const isModalPublicationValidateWalmartVisible = checkModalVisible(
    MODAL_NAMES.PUBLICATION_WALMART_VALIDATE_VIEW_MODAL
  );

  return (
    <>
      {isModalPublicationWalmartVisible && (
        <PublicationSetupModal
          handleCancel={() => {
            setRequestParams([]);
            closeModal(MODAL_NAMES.PUBLICATION_WALMART_SETUP_MODAL);
          }}
          handleOk={(values) => {
            setRequestParams(values);
            openModal(MODAL_NAMES.PUBLICATION_VALIDATE_VIEW_MODAL);
          }}
          isFullView={isFullView}
          productId={productId}
          visible={isModalPublicationWalmartVisible}
          targetType='walmart'
        />
      )}
      {isModalPublicationValidateWalmartVisible && (
        <PublicationValidationView
          requestParams={requestParams}
          isFullView={isFullView}
          productId={productId}
          visible={isModalPublicationValidateWalmartVisible}
          targetType='walmart'
        />
      )}
    </>
  );
};

export default PublicationProductToWalmartRecipients;
